var CartItemSet;
(function (CartItemSet) {
    CartItemSet["Ble"] = "ble";
    CartItemSet["Nfc"] = "nfc";
})(CartItemSet || (CartItemSet = {}));
export default CartItemSet;
//# sourceMappingURL=CartItemSet.js.map